export enum DepartmentSortType {
    Id,
    Name,
    IsDeleted
}
